import React, { useEffect, useState } from "react";
import { useStateAuthValue } from "../../context/Auth/AuthState";
import { GetPetsByPatientId } from "../../services/petService";
import { useHistory } from "react-router";
import TrashIcon from "../../assets/img/trash-bin.png";
import PencilIcon from "../../assets/img/edit.png";
import LoadingSpinner from "../../components/LoadingSpinner";
import { makeStyles } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import PetsIcon from "@material-ui/icons/Pets";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    overflowX: "auto",
    margin: "auto",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      width: 380,
    },
  },
  hiddenOnSmall: {
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  table: {
    minWidth: 400,
    width: "100%",
  },
  tableHead: {
    backgroundColor: "#CEE1FE",
    color: "#000",
    "& th": {
      color: "#000",
      fontWeight: "bold",
    },
  },
  tableRow: {
    "&:nth-of-type(even)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(5),
  },
  emptyIcon: {
    width: 80,
    height: 80,
    opacity: 0.6,
    marginBottom: theme.spacing(2),
  },
  textMuted: {
    color: theme.palette.text.secondary,
  },
  actionButtons: {
    display: "flex",
    gap: "10px",
  },
}));
export const MyPetsScreen = () => {
  const [{ userData, userToken }] = useStateAuthValue();
  const classes = useStyles();
  const history = useHistory();
  const [pets, setPets] = useState([]);
  const [loading, setLoading] = useState(true);

  const getMyPets = async () => {
    try {
      setLoading(true);
      const res = await GetPetsByPatientId(userData.patient_dto.id, userToken);
      const data = res.data;
      setPets(data);
    } catch (e) {
      // console.log({ e });
    } finally {
      setLoading(false);
    }
  };

  const addMember = () => {
    history.push("/mi-plan-modal", { typeClick: "addPet" });
    return;
    // if (!canAddMembers) {
    //   history.push("/mi-plan-modal", { typeClick: "addPet" });
    // } else {
    //   history.push({
    //     pathname: "/nueva-mascota",
    //   });
    // }
  };

  const myPlanHandler = (typeClick = "addPet") => {
    history.push("/mi-plan-modal", { typeClick: typeClick });
  };

  const onSaveHandler = () => {
    history.push("/paciente");
  };

  const editFamilyMember = (id) => {
    const petFound = pets.find((item) => item.id === id);
    if (petFound) {
      history.push({
        pathname: "/nueva-mascota",
        // state: { memberData: per, relationship: per.relationship_to_titular },
        state: { updatePet: petFound },
      });
    }
  };

  const deleteFamilyGroupMember = () => {
    history.push("/mi-plan-modal", { typeClick: "deletePet" });
  };

  useEffect(() => {
    if (
      typeof userData === "object" &&
      userData !== null &&
      !Array.isArray(userData)
    ) {
      getMyPets();
    }
  }, [userData]);

  return (
    <>
      <div className="container">
        <div className="title_container">
          <h2>Mis Mascotas</h2>
        </div>
        <div>
          <div>
            <h5 style={{ padding: "10px 0" }}>
              Titular: {userData?.first_name + " " + userData?.last_name}
            </h5>
          </div>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <>
              <TableContainer
                component={Paper}
                className={classes.tableContainer}
              >
                <Table className={classes.table} aria-label="pets table">
                  <TableHead className={classes.tableHead}>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Nombre</TableCell>
                      <TableCell className={classes.hiddenOnSmall}>
                        Especie
                      </TableCell>
                      <TableCell className={classes.hiddenOnSmall}>
                        Raza
                      </TableCell>
                      <TableCell className={classes.hiddenOnSmall}>
                        Sexo
                      </TableCell>
                      <TableCell>Acciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {pets.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          <Box className={classes.emptyState}>
                            <PetsIcon className={classes.emptyIcon} />
                            <Typography
                              variant="body1"
                              className={classes.textMuted}
                              style={{
                                fontSize: "16px",
                                marginBottom: (theme) => theme.spacing(1),
                              }}
                            >
                              No tienes mascotas registradas aún
                            </Typography>
                            <Typography
                              variant="caption"
                              className={classes.textMuted}
                            >
                              Haz clic en &quot;Agregar Mascota&quot; para
                              comenzar
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ) : (
                      pets.map((member, index) => (
                        <TableRow key={index} className={classes.tableRow}>
                          <TableCell component="th" scope="row">
                            {index + 1}
                          </TableCell>
                          <TableCell>{member.userData.firstName}</TableCell>
                          <TableCell className={classes.hiddenOnSmall}>
                            {member.species}
                          </TableCell>
                          <TableCell className={classes.hiddenOnSmall}>
                            {member.race}
                          </TableCell>
                          <TableCell className={classes.hiddenOnSmall}>
                            {member.userData.sex === "MALE"
                              ? "Macho"
                              : "Hembra"}
                          </TableCell>
                          <TableCell>
                            <Box className={classes.actionButtons}>
                              <img
                                id={member?.id ? member?.id : ""}
                                src={TrashIcon}
                                style={{ cursor: "pointer", height: "1.4rem" }}
                                className="icon"
                                alt="Item menú"
                                onClick={deleteFamilyGroupMember}
                              />
                              <img
                                id={member?.id ? member?.id : ""}
                                src={PencilIcon}
                                style={{ cursor: "pointer", height: "1.4rem" }}
                                className="icon"
                                alt="Item menú"
                                onClick={() => editFamilyMember(member.id)}
                              />
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
        </div>
        <div className="button-container">
          <button
            className="button see-plan-button"
            onClick={() => myPlanHandler("changePlan")}
          >
            Cambio de Plan
          </button>
          <button
            style={{ backgroundColor: "#489633" }}
            className="button second-button"
            onClick={addMember}
          >
            Agregar Mascota
          </button>
        </div>
      </div>
    </>
  );
};
